import { ContextMenuIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import React, { useState } from 'react';

import DownloadActionButton from 'features/DataManagement/components/ActionButton/DownloadActionButton';
import UploadActionButton from 'features/DataManagement/components/ActionButton/UploadActionButton';
import FileUploadDialog from 'features/DataManagement/components/FileUploadDialog';
import useStyles from 'features/DataManagement/components/RowMenuItem/RowMenuItem.styles';
import { DataManagmentUploads } from 'utils/dataManagmentUploads';
import { FILE_UPLOAD_DIALOG_ID } from 'utils/defaults';

type RowMenuItemProps = {
  dataType: string;
  uploadInProgress: boolean;
  canDownload: boolean;
};

const RowMenuItem: React.FC<RowMenuItemProps> = ({ dataType, uploadInProgress, canDownload }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <ContextMenuIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{ 'aria-labelledby': 'long-button' }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{ className: classes.menuPaper }}
      >
        {canDownload && (
          <DownloadActionButton
            dataType={dataType}
            uploadInProgress={uploadInProgress}
            handleClose={handleClose}
          />
        )}
        <UploadActionButton
          dataType={dataType}
          uploadInProgress={uploadInProgress}
          handleClose={handleClose}
          dialogId={`${FILE_UPLOAD_DIALOG_ID}${dataType}`}
        />
      </Menu>
      <FileUploadDialog dataType={dataType as DataManagmentUploads} />
    </div>
  );
};

export default RowMenuItem;
